<template>
  <div>
    <div class="hearderLogo">
      <HeaderSimple></HeaderSimple>
    </div>
    <div class="trackBody">
      <h3 class="text-center trackTitle">{{ username }}的待买清单</h3>
      <div style="display: flex;padding:0 0 20px;height:75%;justify-content: space-between;">
        <div style="width:58%;display: flex;flex-direction: column;">
          <div>
            <div style="display: flex;">
              <h3 style="display: flex;align-items: center;">
                <img :src="`https://pic.joyorders.com/country/${merchant.country.toLowerCase()}.png`"
                  style="width:20px;height:20px;margin-right:5px;object-fit: contain;" />
                <label style="font-size:16px;line-height:25px;">{{ merchant.label }}</label>
              </h3>
              <!--<span style="display: flex;align-items: center;margin-left:15px;">
                <i class="el-icon-user" style="font-size: 16px;color:#333;width:16px;"></i>
                <label>{{ username }}</label>
              </span>-->
            </div>
            <p style="line-height: 18px;margin-bottom: 10px;color: #666;">{{merchant.website}}</p>
          </div>
          <div style="overflow: auto;flex:1;padding:0 15px;border:1px solid #dee2ec">
            <template v-if="list.length">
              <div v-for="(item, index) in list" :key="index" class="goods_row">
                <div style="width:135px;height:135px;">
                  <img v-if="item.picture" :src="item.picture" style="width:100%;height:100%;object-fit:contain" />
                  <img v-if="!item.picture" src="../../../assets/images/offlinePic.png"
                    style="width:100%;height:100%;object-fit:contain" />
                </div>
                <div style="flex:1;padding-left:20px;display: flex;flex-direction: column;justify-content: space-between;">
                  <div>
                    <div style="display: flex;justify-content: space-between;margin-bottom: 3px;">
                      <div>
                        <h4 style="line-height: 20px;color: rgb(51, 51, 51);">{{ item.name }}</h4>
                      </div>
                      <div class="copyGood">
                        <span @click="showCopy(item)"><i class="el-icon-more-outline moreIco">
                        </i></span>
                        <div v-show="item.showCopy" class="copybtn" style="position:absolute;" @click.stop="copyGoods(item)">
                          <p class="copyTxT">
                            <span style="font-size:14px;">复制商品</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <p style="color:#888">{{ item.spec }}</p>
                  </div>
                  <div style="display:flex;justify-content: space-between;align-items: center;">
                    <div>
                      <el-button :disabled="index==current_index" class="gray small" style="height:34px;" type="info" @click="deleteGoods(index)">移除</el-button>
                      <el-button class="gray small" style="margin:0 10px;height:34px;" type="info" @click="switchGoods(index,item)">编辑</el-button>
                      <el-select class="inline-block" style="margin-left:0;top:1px;" v-model="item.number" placeholder="">
                        <el-option
                          v-for="item in 999"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <div class="product-price" v-if="item.discounted_price !== item.price">
                        <del>{{$decimalFormat(+item.price,2)|currency(merchant.currency_symbol)}}</del>
                        <p class="discounted">{{($decimalFormat(+item.discounted_price,2))|currency(merchant.currency_symbol)}}</p>
                      </div>
                      <div class="product-price" v-else>
                        <p style="color:#000000;">{{($decimalFormat(+item.price,2))|currency(merchant.currency_symbol)}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div v-else
              style="display: flex;flex-direction: column;align-items: center;justify-content: center;height:100%">
              <img src="../../../assets/images/empty.png" style="width:100px;height:100px;margin-bottom:15px;" />
              <br />
              <label>还没有要加入的商品</label>
            </div>
          </div>
        </div>
        <div
          style="width:38%;height:100%;display: flex;flex-direction: column;justify-content: center;">
          <ul class="error-messages" v-if="errormessage">
            <li>{{ errormessage }}</li>
          </ul>
          <div>
            <div style="width:135px;height:135px;margin:0 auto 25px;">
              <img v-if="current_goods.picture" :src="current_goods.picture" style="width:100%;height:100%;object-fit:contain;" />
              <img v-else src="../../../assets/images/offlinePic.png" style="width:100%;height:100%;object-fit:contain;" />
            </div>
            <div style="margin-bottom: 10px;position:relative;">
              <YueDanIpt model="picture" :object="current_goods" placeholder="商品图片网址"></YueDanIpt>
              <el-upload :action="API_HOST + '/api/order_v2.php?api=upload_picture'" :on-success="handleRelationSuccess"
                :headers="headers" :before-upload="beforeRelationUpload" name="picture"
                style="position:absolute;right:5px;top:10px;z-index:999;">
                <el-button size="small" type="info">本地上传</el-button>
              </el-upload>
            </div>
            <!--<el-upload v-if="!current_goods.picture" :action="API_HOST + '/api/order_v2.php?api=upload_picture'"
              :on-success="handleRelationSuccess" :before-upload="beforeRelationUpload" :headers="headers"
              name="picture">
              <div class="add-picture" style="width:120px;height:130px;">
                <i class="el-icon-plus" style="font-size:20px;color:rgb(136,136,136);font-weight: bold;"></i>
                <label style="color:rgb(136,136,136);margin-top:10px;">上传图片</label>
              </div>
            </el-upload>
            <div v-else class="realation_image_wrapper">
              <img :src="current_goods.picture" style="width:100%;height:100%;object-fit:contain;" />
              <div class="operations on">
                <div class="operation del" @click.stop="deleteImage">
                  <i class="el-icon-close" style="color:white;"></i>
                </div>
              </div>
            </div>-->
            <div style="position: relative;">
              <YueDanIpt style="margin-bottom:10px;" model="website" :object="current_goods" placeholder="商品网址"></YueDanIpt>
              <YueDanIpt style="margin-bottom:10px;" model="name" :object="current_goods" placeholder="商品名称"></YueDanIpt>
              <div style="display: flex;margin-bottom:10px;justify-content: space-between;">
                <YueDanIpt style="flex:1;" model="spec" :object="current_goods" placeholder="商品规格"></YueDanIpt>
                <el-select class="inline-block height50" style="height:50px;margin-left:10px;" v-model="current_goods.number" placeholder="">
                  <el-option
                    v-for="item in 999"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div style="display: flex;margin-bottom:10px;justify-content: space-between;">
                <YueDanIpt style="width:48%;" type="number" model="price" :object="current_goods" placeholder="价格" :append="merchant.currency"></YueDanIpt>
                <YueDanIpt style="margin-left:10px;flex:1" type="number" model="discounted_price" :object="current_goods" placeholder="折扣价" :append="merchant.currency"></YueDanIpt>
              </div>
            </div>
          </div>
          <div style="bottom:15px;width:100%;display: flex;justify-content: space-between;">
            <template v-if="editMode">
              <el-button style="width:49%" class="nohover" type="default" @click="clearGoods">取 消</el-button>
              <el-button style="width:49%" class="nohover" type="info" @click="addGoods">保 存</el-button>
            </template>
            <template v-else>
              <el-button style="width:49%" class="nohover" type="default" @click="clearGoods">清 空</el-button>
              <el-button style="width:49%" class="nohover" type="info" @click="addGoods">添 加</el-button>
            </template>
          </div>
        </div>
      </div>
      <div style="margin-top:20px;padding:0 10px;display: flex;justify-content: space-between;align-items: center;">
        <div style="width:58%;text-align: right;padding-right:15px;">
          <label style="font-size: 22px;line-height: 30px;">商品总计：</label><label style="color:#686b73;font-size: 24px;">{{ merchant.currency_symbol }}{{ $decimalFormat(totalPrice,2)}}</label>
        </div>
        <div style="width:38%;">
          <el-button :disabled="list.length==0" class="block nohover fontsize" type="info" @click="confirm" icon='el-icon-shopping-bag-2'>添 加 至 待 买 清 单</el-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
//import { formatSpec, showProductName } from "../../../services/tools";
import YueDanIpt from '../../../components/YueDanIptEx'
import HeaderSimple from '../../../components/HeaderSimple';
//import api from "../../../services/api";
import { API_HOST } from '../../../services/constant.js'

let _ = require('lodash')

export default {
  name: 'Collapse',
  props: ['username', 'merchant'],
  components: {
    HeaderSimple: HeaderSimple,
    YueDanIpt:YueDanIpt
  },
  computed: {
    totalPrice() {
      let result = 0;
      console.log('test',this.list);
      this.list.forEach((l) => {
        result += (+l.discounted_price) * (+l.number)
      })
      return result
    }
  },
  data() {
    return {
      current_index:-1,
      editMode: false,
      errormessage: '',
      API_HOST: API_HOST,
      headers: {},
      list: [],
      current_goods: {
        number:'1',
        picture:'',
        website:''
      },
      upload_relation_image_width: 0
      //showProductName: showProductName,
      //formatSpec: formatSpec,
    }
  },
  created() {
    this.headers.token = this.$localStorage.get('token');

  },
  mounted() {

  },
  methods: {
    copyGoods(goods){
      goods.showCopy=false;
      this.current_index=-1;
      this.editMode=false;
      this.current_goods = JSON.parse(JSON.stringify(goods));
    },
    showCopy (goods) {
      _.each(this.list, item => {
        if (item.id != goods.id) {
          item.showCopy = false
        }
      })
      goods.showCopy = !goods.showCopy
      this.$forceUpdate()
    },
    switchGoods(index,item) {
      this.current_index = index;
      this.editMode = true;
      this.current_goods = item
    },
    clearGoods() {
      this.editMode = false;
      this.current_index = -1;
      this.current_goods = {
        number:'1',
        picture:'',
        website:''
      };
    },
    handleImageLoad(event, index) {
      const img = event.target;
      const aspectRatio = img.naturalWidth / img.naturalHeight;
      this.upload_relation_image_width = 200 * aspectRatio;
    },
    deleteImage() {
      this.current_goods.picture = '';
      this.$forceUpdate();
    },
    deleteGoods(index) {
      this.list.splice(index, 1);
    },
    addGoods() {
      this.errormessage = ''
      if (!this.current_goods.name) {
        this.errormessage = '商品名称是必填项';
        return;
      }
      if (!this.current_goods.website) {
        this.errormessage = '商品网址是必填项';
        return;
      }
      if (!this.current_goods.price) {
        this.errormessage = '商品价格是必填项';
        return;
      }
      this.current_goods.discounted_price = this.current_goods.discounted_price || this.current_goods.price;
      let obj = JSON.parse(JSON.stringify(this.current_goods))
      if (this.editMode) {
        this.list[current_index] = obj;
        this.editMode = false;
        this.current_index = -1;
      }
      else {
        this.list.push(obj);
      }
      this.current_goods = {
        number:'1',
        picture:'',
        website:''
      };
    },
    cancel() {
      this.$emit('canceladdcart')
    },
    confirm() {
      let data = this.list.map((l) => {
        return {
          good_id: 0,   // 手动添加商品标识
          time: +new Date(),   // 做特有id
          business_id: this.merchant.value,
          merchant_name: this.merchant.label,
          business_name: this.merchant.label,
          business_website: l.website,
          name: l.name,
          website: l.website,
          spec: l.spec ? l.spec.replace(/\n/g, '') : '',
          number: "1",
          price: l.price,
          discounted_price: l.discounted_price,
          picture: l.picture,
          currency: this.merchant.currency,
          country: this.merchant.country,
          currency_symbol: this.merchant.currency_symbol,
          single_service_rate: this.merchant.single_service_rate,
          buyer_service_rate: this.merchant.buyer_service_rate,
          single_fixed_amount: this.merchant.single_fixed_amount,
          buyer_fixed_amount: this.merchant.buyer_fixed_amount,
        }
      })
      this.$emit('confirmAddCart', data)
    },
    beforeRelationUpload(params) {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
      const isAllowed = allowedTypes.includes(params.type);
      const isLt2M = params.size / 1024 / 1024 < 32;

      if (!isAllowed) {
        this.$message.error('只能上传 png、jpg、jpeg、webp 格式的图片!');
      }
      if (!isLt2M) {
        this.$message.error('文件大小不能超过 32MB!');
      }
      return isAllowed && isLt2M;
    },
    handleRelationSuccess: function (response) {
      this.current_goods.picture = response.result;
      this.$forceUpdate();
    },
  },

}

</script>

<style scoped lang="scss">
.mobile-button {
        padding: 10px 10px !important;
      }
      .mobile-button+.mobile-button {
        margin-left: 2px !important;
      }
.copyGood{
  position: relative;
  cursor: pointer;
}
.copybtn{
  position: absolute;
  left: -90px;
  top: -11px;
  width: 90px;
  border: 1px solid #d7d7d7;
  line-height: 36px;
  padding: 0 5px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  background: #fff;
}
.copyTxT{
  text-align: center;
}
.moreIco{
  transform: rotate(90deg);
}
.product-price {
  .discounted {
    color: #ff4650;
  }
}

.error-messages {
  background-color: #fff1f1;
  padding: 10px;
  text-align: center;
  color: #ff4650;
  line-height: 17px;
  margin-bottom: 10px;
  border-radius: 5px;

  li {
    font-size: 12px;
  }
}

.goods_row {
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid #ccc;
}

.realation_image_wrapper {
  width: 120px;
  height: 100px;
  position: relative;
}

.operations {
  display: none;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 100;
  width: 20px;
  height: 20px;

  .del {
    background: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.realation_image_wrapper:hover {
  .on {
    display: block;
  }
}

.add-picture {
  width: 60px;
  height: 60px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: rgb(247, 247, 247);
  margin-bottom: 10px;
}

.add-picture-img {
  position: relative;
  margin-left: 12px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.hearderLogo {
  position: absolute;
  width: 80%;
  top: 0;
  left: 10%;

  .header {
    padding: 50px 0;
  }
}

.trackBody {
  overflow: hidden;
  width: 980px;
  margin: 52px auto 23px;
  background: #fff;
  padding: 40px 50px;


  .trackTitle {
    font-size: 18px;
    color: #333333;
    font-weight: 500;
    letter-spacing: 2px;
    margin-bottom: 41px;
    padding-right: 55px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/cart/AddCart.vue